import React from "react";

import Layout from "../../../components/layout/layout";
import { PlayerProfile } from "../../../components/table/playerprofile";

export default function PlayerProfileTable({ component, ...rest }) {
  return <Layout Component={PlayerProfile} controlsDisabled={true} {...rest} />;
}
